import { useRemovePreset } from '@restDataAccess/camera/cameraControlApi.dataHooks.ts';
import { PresetInfo } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

import { ConfirmDeleteDialog, useFeedbackAlert } from '@/components';
import { ModalControllerType } from '@/types.ts';

export const RemovePresetConfirmModal = ({
  modalController,
  onSaved,
  preset,
}: {
  modalController: ModalControllerType;
  onSaved: (saved: { name: string; operation: 'deleted' }) => void;
  preset: PresetInfo;
}) => {
  const { t } = useTranslation();
  const { feedback, setFeedback, clearFeedback } = useFeedbackAlert();
  const { mutate, isPending } = useRemovePreset();

  const handleClose = () => {
    modalController.onClose();
    clearFeedback();
  };

  const handleConfirmDelete = () => {
    mutate(
      { id: preset.id },
      {
        onSuccess: () => {
          handleClose();
          onSaved({ name: preset.name, operation: 'deleted' });
        },
        onError: error => {
          const message = error instanceof Error ? error.message : '';
          setFeedback({
            text: t('snackbar.error.delete', { name: preset.name, message }),
            variant: 'alarm',
          });
        },
      }
    );
  };

  return (
    <ConfirmDeleteDialog
      open={modalController.open}
      onClose={handleClose}
      onConfirm={handleConfirmDelete}
      itemName={preset.name}
      loading={isPending}
      feedback={feedback}
      onFeedbackDismiss={clearFeedback}
    />
  );
};
